/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Error, ErrorIcon, ErrorTitle, ErrorDescription } from '@quadminds/mindkit';
import IconDark from '@quadminds/mindy-app/assets/img/errors/GeoDark.svg';
import IconLight from '@quadminds/mindy-app/assets/img/errors/GeoLight.svg';
import { useTranslation } from 'react-i18next';

export function GeoLimitExceeded() {
    const { t } = useTranslation();
    return (
        <Error>
            <ErrorIcon>
                <img src={IconLight} alt="Error" className="dark:hidden h-24 w-auto" />
                <img src={IconDark} alt="Error" className="hidden dark:block h-24 w-auto" />
            </ErrorIcon>
            <ErrorTitle>{t('errors.geocodeLimitReached')}</ErrorTitle>
            <ErrorDescription>{t('errors.geocodeError')}</ErrorDescription>
        </Error>
    );
}

export default GeoLimitExceeded;
